import { __spreadArray } from "tslib";
import { createSelector } from 'reselect';
import { actionKey } from './constants';
function getSlice(state) {
    return (state[actionKey] || {
        fileUploads: [],
        fileUploadsWaiting: [],
    });
}
export var getUploads = createSelector(getSlice, function (slice) { return slice.fileUploads; });
export var getUploadsWaiting = createSelector(getSlice, function (slice) { return slice.fileUploadsWaiting; });
export var getAllUploads = createSelector(getUploads, getUploadsWaiting, function (uploads, uploadsWaiting) { return __spreadArray(__spreadArray([], uploads, true), uploadsWaiting, true); });
export var getUploadById = createSelector(getAllUploads, function (state, fileId) { return fileId; }, function (allUploads, fileId) {
    return allUploads.find(function (fu) { return fu.fileId === fileId; });
});
export var getUploadsByTag = createSelector(getAllUploads, function (state, tag) { return tag; }, function (allUploads, tag) { return allUploads.filter(function (fu) { return fu.tag === tag; }); });
//# sourceMappingURL=selectors.js.map